import equalByNameAndPaymentParamId from '../../utils/equalByNameAndPaymentParamId';
import {i18n} from "../../../vue-i18n";

export default class PaymentDeletion {
  constructor(paymentParametersId) {
    this.commandName = "PaymentDeletion";
    this.paymentParametersId = paymentParametersId;
    this.description =
      `${i18n.t('CONTENT.events.remove_payment')}: ${paymentParametersId}`;
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        PaymentParametersId: this.paymentParametersId
      })
    }
  }

  equal = (other) => equalByNameAndPaymentParamId(this, other);
}
